import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { MatIconModule } from "@angular/material";

import { AppComponent } from './app.component';
import { FotoCarouselComponent } from './foto-carousel/foto-carousel.component';
import { MomentCardComponent } from './moment-card/moment-card.component';
import { NavbarComponent } from './navbar/navbar.component';
import { AddMomentComponent } from './add-moment/add-moment.component';
import { PageNoteFoundComponent } from './page-note-found/page-note-found.component';
import { HomeComponent } from './home/home.component';



import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';


import { FIREBASE_CONFIG } from './app.env.config'
import { AngularFireModule } from 'angularfire2'
import { AngularFireAuthModule } from 'angularfire2/auth'
import { AngularFireDatabaseModule } from 'angularfire2/database'
import { AngularFireStorageModule } from 'angularfire2/storage';


import { HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [
    AppComponent,
    FotoCarouselComponent,
    MomentCardComponent,
    NavbarComponent,
    AddMomentComponent,
    PageNoteFoundComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    MatIconModule,
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    HttpClientModule,
    AppRoutingModule,
    AngularFireStorageModule,
    FormsModule,
    MDBBootstrapModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/app.module.ts